import object from 'helpers/object'


export const initialState = {
  ordersData: [],
  classes: {},
  schools: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const resetOrders = (state) => (
  object.setIn(state, [ 'ordersData' ], [])
)

// export const setOrdersData = (state, payload) => (
//   object.setIn(state, [ 'ordersData' ], [ payload ])
// )

export const updateOrdersData = (state, payload) => (
  object.setIn(state, [ 'ordersData' ], state.ordersData.concat(payload))
)

export const setClasses = (state, payload) => (
  object.setIn(state, [ 'classes', payload.schoolId ], payload.classes)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)
